<template>
  <div
    class="block rounded shadow-xs"
    @click="showModal"
    :class="[focus ? 'border border-gray-700' : '']"
  >
    <div class="rounded shadow-md overflow-hidden bg-white text-xs">
      <KanbanBoardTaskListLineProject v-if="project" :project="project" />
      <div v-if="task.title" class="p-2">
        {{ task.title }}
      </div>
      <KanbanBoardTaskListLineDue :task="task" />
      <div v-if="assignee" class="px-2 py-1 text-gray-700 bg-gray-100">
        Assigned to: {{ assignee.fullName }}
      </div>
      <KanbanBoardTaskListLineMeta :task="task" />
    </div>
  </div>
</template>

<script>
import KanbanBoardTaskListLineProject from './KanbanBoardTaskListLineProject.vue';
import KanbanBoardTaskListLineDue from './KanbanBoardTaskListLineDue.vue';
import KanbanBoardTaskListLineMeta from './KanbanBoardTaskListLineMeta.vue';

export default {
  name: 'TaskListLine',

  components: {
    KanbanBoardTaskListLineProject,
    KanbanBoardTaskListLineDue,
    KanbanBoardTaskListLineMeta,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
    focus: Boolean,
  },

  computed: {
    task() {
      return this.$store.state.entities.tasks.byId[this.id];
    },
    project() {
      if (!this.task.projectId && !this.task.project) {
        return undefined;
      }

      return this.$store.state.entities.projects.byId[this.task.projectId || this.task.project];
    },
    assignee() {
      if (!this.task.userAssignedId) {
        return undefined;
      }

      return this.$store.state.entities.users.byId[this.task.userAssignedId];
    },
  },

  watch: {
    task: {
      handler(task, oldTask) {
        this.$emit('task:updated', { task, oldTask });
      },
    },
  },

  methods: {
    showModal() {
      this.$emit('selected-task', this.id);
      this.$modal.show({
        component: 'ProjectTaskModal',
        props: {
          taskId: this.id,
        },
        on: {},
        hideEvent: 'task-modal:closed',
      });
    },
  },
};
</script>
